// Needed for redux-saga es6 generator support
import "babel-polyfill";

import React from "react";
import ReactDOM from "react-dom";
import configureStore from "./store";
import { Provider } from "react-redux";
import Stream from "./containers/Stream";
import Tour from "./containers/Tour";
// Import i18n messages
import { translationMessages } from "./i18n_react";
import LanguageProvider from "./containers/LanguageProvider";
import STEPS_CONTENT from "./containers/Tour/steps-content";

// Create redux store
const store = configureStore();

const injectTranslations = (reactElements = [], translationMessages) => {
  reactElements.forEach(element => {
    if (element) { element(translationMessages); }
  });
};

// render React elements
$(document).on("DOMContentLoaded", () => {
  let tourRender, streamRender;

  // Tour rendering
  const tourContainer = document.getElementById("js-tour-container");
  const tourType = tourContainer ? tourContainer.dataset.tour : null;

  if (tourContainer && tourType && STEPS_CONTENT[tourType] && !localStorage.getItem(tourType)) {
    MyAD.checkTour(tourType, null, function (data, tourType) {
      if (data.status === "seen") {
        localStorage.setItem(tourType, tourType);
      } else if (data.status === "show") {
        tourRender = messages => {
          ReactDOM.render(
            <Provider store={store}>
              <LanguageProvider messages={messages} store={store}>
                <Tour store={store} tourType={tourType} />
              </LanguageProvider>
            </Provider>,
            tourContainer
          );
        };
        injectTranslations([tourRender], translationMessages);
      }
    });
  }

  // Stream React component
  const stream = document.getElementById("myad-stream");
  if (stream) {
    streamRender = (messages) => {
      ReactDOM.render(
        <Provider store={store}>
          <LanguageProvider messages={messages} store={store}>
            <Stream store={store} />
          </LanguageProvider>
        </Provider>
        ,
        stream
      );
    };
  }

  // Chunked polyfill for browsers without Intl support
  if (!window.Intl) {
    new Promise(resolve => {
      resolve(import("intl"));
    })
      .then(() =>
        Promise.all([
          import("intl/locale-data/jsonp/en.js"),
          import("intl/locale-data/jsonp/es.js"),
          import("intl/locale-data/jsonp/pt.js"),
          import("intl/locale-data/jsonp/zh.js")
        ])
      )
      .then(() => injectTranslations([tourRender, streamRender], translationMessages))
      .catch(err => {
        throw err;
      });
  } else {
    injectTranslations([tourRender, streamRender], translationMessages);
  }
});
